import { gql } from '@apollo/client'

export const INVITE_TO_EVENT = gql`
    mutation InviteToEvent($input: inviteToEventInput!) {
        inviteToEvent(input: $input) {
            event {
                ... on Event {
                    guid
                }
            }
            status {
                item
                status
            }
        }
    }
`
